/**
 * İPUCU (tooltip) SÖZLEŞMESİ — TEK KAYNAK.
 *
 * Karar: kullanıcı 24.09.2026 (kesilen metnin tamamı tarayıcının `title`ı
 * değil tasarım sisteminin ipucusuyla okunur). Tasarım: Claude Design,
 * `docs/design/ipucu/WarmBreak İpucu - Tooltip Bileşeni.dc.html`
 * (01 Anatomi · 02 Yerleşim · 03 Uzun metin · 04 Tema · 06 Etkileşim).
 *
 * NEDEN `tokens.ts`TE DEĞİL: `tokens.ts` dosya tavanında donmuş
 * (`file-size-ceiling.guard.spec`, 630). `section-heading.ts` ve
 * `auth-panel.ts` emsaliyle bileşen sözleşmesi ayrı dosyadadır; ölçüler
 * merdivenlerden TÜRETİLİR, renkler paletten ALINIR. Yeni renk ya da yeni
 * basamak İCAT EDİLMEDİ; 13 px punto ve 1,45 satır aralığı referansın
 * ipucuya özgü değerleridir (ölçekte yok). Süreler `motion` ailesine
 * bağlıdır (`tooltipMotion`): görünme `duration.fast`, eğri `standard`;
 * yalnız ipucuya özgü üç bekleme burada sayı olarak durur.
 *
 * Boru hattı: `packages/ui/src/theme-css.ts` bunları `--ib-tip-*`,
 * `--ib-z-*` ve moda bağlı `--ib-color-tooltip-*` olarak basar.
 */
import { motion, palette, radius, spacing, typography } from './tokens';
/**
 * Ölçüler (referans 01 · 03). `maxLines` TAVANDIR, kırpma değildir: altı
 * satırı aşan metin ipucunun işi değil, bileşen o metinde ipucuyu hiç açmaz.
 */
export const tooltip = {
    maxWidth: 320,
    paddingY: spacing.sm,
    paddingX: spacing.md,
    radius: radius.md,
    fontSize: 13,
    lineHeight: 1.45,
    fontWeight: typography.fontWeight.medium,
    arrow: 8,
    offset: spacing.sm,
    edge: spacing.sm,
    shift: spacing.xxs,
    maxLines: 6,
};
/**
 * Zamanlama (referans 06). Klavye odağında gecikme yoktur (0), o yüzden
 * token'ı da yoktur. `delaySkip`: başka bir ipucu açıkken geçiş.
 */
export const tooltipMotion = {
    delayIn: 500,
    delaySkip: 150,
    delayOut: 100,
    duration: motion.duration.fast,
    easing: motion.easing.standard,
};
/**
 * Renkler (referans 04). Açık temada zemin ink, metin karanlık paletin ink'i;
 * kenar zeminle aynı ("1px, zeminle aynı"), ayrımı `md` gölge yapar. Koyu
 * temada zemin bir kademe yükseltilmiş yüzey, ayrımı 1 px `lineStrong` kenar
 * yapar (gölge koyu zeminde ayrıştırmaz).
 */
export const tooltipColors = {
    light: { surface: palette.neutral.ink, text: palette.dark.ink, border: palette.neutral.ink },
    dark: { surface: palette.dark.raised, text: palette.dark.ink, border: palette.dark.lineStrong },
};
/**
 * Yığın sırası. Açılır menüler 40'tır; ipucu menünün ÜSTÜNDE durur ve menüyü
 * kapatmaz (referans 05-C). Menü modülleri bugün 40'ı literal yazıyor; değer
 * aynıdır, modüller bu turda taşınmadı.
 */
export const layer = {
    menu: 40,
    tooltip: 41,
};
//# sourceMappingURL=tooltip.js.map